/**
 * Lesson icons. Onboarding Studio publishes lucide names (`LogIn`, `Rocket`…); the console draws Material Symbols
 * (components/Icon.tsx), so the known names are mapped explicitly and anything else falls back to a neutral icon.
 * A Material Symbols name the map already uses is accepted as is.
 */

export const FALLBACK_LESSON_ICON = 'school';

const LUCIDE_TO_SYMBOL: Record<string, string> = {
  LogIn: 'login',
  LayoutDashboard: 'dashboard',
  Gauge: 'monitoring',
  BarChart: 'monitoring',
  BarChart3: 'monitoring',
  Package: 'inventory_2',
  PackagePlus: 'inventory_2',
  Boxes: 'apps',
  AppWindow: 'apps',
  Smartphone: 'phone_iphone',
  Rocket: 'rocket_launch',
  Hammer: 'construction',
  Wrench: 'construction',
  Construction: 'construction',
  Key: 'key',
  KeyRound: 'key',
  Lock: 'lock',
  Shield: 'shield',
  ShieldCheck: 'shield',
  Users: 'group',
  User: 'person',
  UserPlus: 'person_add',
  Building: 'domain',
  Building2: 'domain',
  Terminal: 'terminal',
  GitBranch: 'account_tree',
  GitCommit: 'commit',
  Plug: 'hub',
  Cable: 'hub',
  Webhook: 'webhook',
  SlidersHorizontal: 'tune',
  Settings: 'settings',
  History: 'history',
  Bell: 'notifications',
  Download: 'download',
  Upload: 'upload',
  ScrollText: 'description',
  FileText: 'description',
  Store: 'storefront',
  Tags: 'sell',
  MapPin: 'location_on',
  Book: 'menu_book',
  BookOpen: 'menu_book',
  GraduationCap: 'school',
  PlayCircle: 'play_circle',
};

const KNOWN_SYMBOLS = new Set(Object.values(LUCIDE_TO_SYMBOL));

/** The Material Symbols name for a published icon name; the neutral fallback when unknown or missing. */
export function lessonIconOf(name: string | null | undefined): string {
  if (!name) return FALLBACK_LESSON_ICON;
  return LUCIDE_TO_SYMBOL[name] ?? (KNOWN_SYMBOLS.has(name) ? name : FALLBACK_LESSON_ICON);
}
